import { AddressModel } from '../address.model';
import WarehouseCartModel from './warehouse-cart.model';
import { BaseModel } from '../_base.model';
import { WarehouseAisleModel } from './warehouse-aisle.model';

export class WarehouseModel extends BaseModel {
  id: number;
  name: string;
  address: AddressModel;
  companyAddressId?: number;
  companyAddress: AddressModel = new AddressModel();
  active: boolean;
  type: string;
  locationHasInventory: boolean;
  isDefault: boolean;
  allowAutoAdjustment: boolean;
  autoAssignBoxesToMerchantOrders: boolean;
  autoAdjustmentDate: Date;
  link: string;
  skuField: string;
  quantityField: string;
  enabledForReorder: boolean;
  warehouseCarts: WarehouseCartModel[];
  warehouseAisles: WarehouseAisleModel[];
  USPSPickUpTime?: string | null;
  UPSPickUpTime?: string | null;
  FedExPickUpTime?: string | null;
}